import { createContext, useContext, type ReactElement } from 'react';
import { Icon, IconButton, Tooltip } from '@chakra-ui/react';
import { TbMaximize, TbMinimize } from 'react-icons/tb';

const ReportingChartFullscreenContext = createContext(false);

export const ReportingChartFullscreenProvider = ReportingChartFullscreenContext.Provider;

export function useReportingChartFullscreen(): boolean {
    return useContext(ReportingChartFullscreenContext);
}

interface ReportingChartFullscreenButtonProps {
    isFullScreen: boolean;
    onToggle: () => void;
}

export function ReportingChartFullscreenButton({
    isFullScreen,
    onToggle,
}: ReportingChartFullscreenButtonProps): ReactElement {
    return (
        <Tooltip label={isFullScreen ? 'Exit full screen' : 'Full screen'} placement="top" hasArrow>
            <IconButton
                aria-label={isFullScreen ? 'Exit full screen' : 'Full screen'}
                icon={<Icon as={(isFullScreen ? TbMinimize : TbMaximize) as React.ElementType} boxSize={4} />}
                size="sm"
                h="32px"
                w="32px"
                variant="outline"
                borderColor="gray.300"
                color="gray.600"
                borderRadius="md"
                _hover={{ bg: 'gray.50' }}
                _active={{ bg: 'gray.100' }}
                onClick={onToggle}
            />
        </Tooltip>
    );
}
